import { MovableWindowType } from './interface';
import { compose } from './compose';
import Container from './container';
import withSuccessRateMovableWindow from './components/sucess-rate-chart';
import { MovableWindowChart } from './components/movable-window-chart';

const MovableWindows: React.FC<MovableWindowType> = compose(
  Container,
  withSuccessRateMovableWindow,
)(MovableWindowChart);

export default MovableWindows;
